import axios from './categoryInstance';
import { Category, FlattedCategory, Image } from "@/types/category";
import sortByPriorityThenId from '@/utils/sortByPriorityThenId';





export default async (): Promise<FlattedCategory[]> => {
    try {

        // Fetch categories
        const response = await axios.get<{ contents: Category[] }>(`/categories/`);
        const contents = response.data.contents;
        if (!contents) return [];

        // Keep Admin Portal ordering identical to the Customizer runtime.
        const list = [...contents].sort(sortByPriorityThenId);



        // Helper functions to transform category and image
        const flattenCategory = (category: Category): FlattedCategory => ({
            name: category.name,
            type: 'category',
            id: category.id,
            img: category.category_image_url,
            description: category.description,
            parent: category.parent_id,
            showOnHome: category.show_on_home,
            isActive: category.is_active,
            // The API resolves the stored NULL (a category predating the flag) to true,
            // so an absent value means generic rather than non-generic.
            isGeneric: category.generic ?? true,
            childCount: category.images?.length || 0,
            childCategory: list.filter((c) => c.parent_id === category.id).length || null,
            priority: category.priority,
        });
        const flattenImage = (image: Image, category: Category): FlattedCategory => ({
            name: category.name,
            type: 'image',
            id: image.id,
            img: image.url,
            description: category.description,
            parent: category.id,
            showOnHome: false,
            isActive: category.is_active,
            uploading: "done",
            priority: image.priority,
        });



        // Reduce to flattened list of categories and images
        return list.reduce((acc: FlattedCategory[], category) => {
            acc.push(flattenCategory(category));
            if (category?.images?.length > 0 ) {
                acc.push(
                    ...[...category.images]
                        .sort(sortByPriorityThenId)
                        .map(image => flattenImage(image, category)),
                );
            }
            return acc;
        }, []);



    } catch (error) {
        console.error("Error fetching categories:", error);
        throw new Error("Failed to fetch categories");
    }
};
